import { styled } from "@vitality-ds/system";
import BaseCalloutDescriptionStyles from "./styles/BaseCalloutDescription.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseCalloutDescription = styled("span", BaseCalloutDescriptionStyles);